module.exports = __webpack_public_path__ + "img/RORBPJR40026.a9caef31.png";